<template>
  <!-- weird v-if beacause of event handlers  -->
  <div
    v-if="isReport"
    class="menu-drilldown"
    ref="menuDrilldown"
  >
    <menu-drilldown-breadcrumbs
      ref="shadowBreadcrumbs"
      :drill="drill"
      :shadow="true"
      @resize="handleBreadcrumbsResize"
    ></menu-drilldown-breadcrumbs>

    <div class="menu-drilldown__breadcrumbs-wrapper">
      <menu-drilldown-breadcrumbs
        :drill="visibleDrill"
        @click="setPosition"
        @close="handleCloseDrilldown"
        @slice-exclude="handleSliceExclude"
      ></menu-drilldown-breadcrumbs>
    </div>

    <ui-button
      v-if="hiddenDrillsCount > 0"
      class="menu-drilldown__hidden-drills-count"
      :text="t('{0} more', [hiddenDrillsCount])"
      icon="fas fa-bars"
      size="mini"
      :hide-details="1"
      :menu-list="restItems"
    >
      <template #item="{ item }">
        <menu-drilldown-menu-list-item
          :title="item.title"
          @click="setPosition(item.key)"
          @close="handleCloseDrilldown(item.key)"
        ></menu-drilldown-menu-list-item>
      </template>
    </ui-button>
  </div>
</template>

<script setup lang="ts">
import { useI18n, useMenuDrilldown } from '@/composables';
import MenuDrilldownBreadcrumbs from '@/views/reports/views/menu-drilldown/menu-drilldown-breadcrumbs.vue';
import MenuDrilldownMenuListItem from '@/views/reports/views/menu-drilldown/menu-drilldown-menu-list-item.vue';

const { t } = useI18n();

const {
  isReport,
  drill,
  menuDrilldown,
  visibleDrill,
  hiddenDrillsCount,
  restItems,
  handleBreadcrumbsResize,
  handleCloseDrilldown,
  handleSliceExclude,
  setPosition,
} = useMenuDrilldown();
</script>

<style lang="scss">
  .menu-drilldown {
    display: flex;
    align-items: center;
    justify-content: space-between;
    overflow: hidden;

    &__hidden-drills-count {
      margin-top: 0;
      margin-bottom: 0
    }

    &__breadcrumbs-wrapper {
      overflow: hidden;
    }
  }
</style>
